import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-center" }
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_tooltip, { location: "bottom" }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn, _mergeProps({
          variant: "plain",
          icon: "",
          density: "compact",
          href: $setup.erpUrl,
          target: "_blank"
        }, props), {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-open-in-new", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["href"])
      ]),
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("span", null, "Ouvrir l'URL dans un nouvel onglet", -1))
      ]),
      _: 1
    }),
    _createVNode(_component_v_tooltip, { location: "bottom" }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn, _mergeProps({
          variant: "plain",
          icon: "",
          density: "compact",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.copyUrl($setup.erpUrl)), ["prevent"]))
        }, props), {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-clipboard-arrow-left-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("span", null, "Copier le lien", -1))
      ]),
      _: 1
    }),
    _createElementVNode("input", {
      ref: "hiddenUrl",
      type: "hidden",
      value: $setup.erpUrl,
      tabindex: "-1",
      "aria-hidden": "true"
    }, null, 8, _hoisted_2)
  ]))
}